import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useState } from 'react';

import SampleDetailClinicalReportModal from './SampleDetailClinicalReportModal';
import type { SampleDetail, SampleDetailClinicalReport } from './types';

type SampleDetailClinicalReportsSectionProps = {
  onReportGenerated?: () => void;
  sample?: SampleDetail;
};

const clinicalReportColumns: ColumnsType<SampleDetailClinicalReport> = [
  {
    title: 'Created on',
    dataIndex: 'created',
    key: 'created',
  },
  {
    title: 'Created by',
    dataIndex: 'created_by',
    key: 'created_by',
  },
  {
    title: 'Panel',
    dataIndex: 'panel',
    key: 'panel',
  },
];

const SampleDetailClinicalReportsSection = ({
  onReportGenerated,
  sample,
}: SampleDetailClinicalReportsSectionProps) => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  return (
    <section className="sample-detail__clinical-reports">
      <div className="sample-detail__clinical-reports-header">
        <h3>Clinical reports</h3>
        <Button
          type="primary"
          className="sample-detail__clinical-reports-button"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => setIsReportModalOpen(true)}
        >
          Report
        </Button>
      </div>
      <Table
        columns={clinicalReportColumns}
        dataSource={sample?.clinical_reports ?? []}
        pagination={false}
        rowKey="id"
      />
      <SampleDetailClinicalReportModal
        open={isReportModalOpen}
        sample={sample}
        onReportGenerated={onReportGenerated}
        onClose={() => setIsReportModalOpen(false)}
      />
    </section>
  );
};

export default SampleDetailClinicalReportsSection;
